<person-selector>
  <a
    class="x"
    href="#"
    onclick={event => onClose(event)}
  >
    schließen
    <dfk-icon type="cross" width="20px" height="20px"></dfk-icon>
    <div is="fixed-relative"></div>
  </a>
  
  <h2>Personen</h2>

  <div class="mb-4">
    <div is="foldout">
      <div is="dfk-raw" html={t('widget_person')} class="text-justify" />
    </div>
  </div>

  <dfk-input
    name="filter"
    placeholder={cap(t('filter'))}
    update-handler={values => sortApply(values)}
  />

  <div class="header">
    <div class="d-flex flex-column align-items-end">
      <dfk-pagination
        if={state.data}
        total={state.data.total}
        page={state.data.page}
        per-page={state.data.perPage}
        page-to={values => onPageTo(values['page'])}
      />
    </div>
  </div>

  <table class="table mt-1">
    <thead>
      <tr>
        <td class="pl-0">
          <dfk-input
            name="filter"
            type="checkbox"
            update-handler={values => checkAll()}
          />
        </td>
        <td>
          <table class="inner">
            <tr
              is="order-control"
              ref="sort"
              fields={state.fields}
              existing={sortExisting}
              apply-new={sortApply}
            ></tr>
          </table>
        </td>
        <td class="text-right">
          <a href="#" onclick={event => expandAll(event)}>
            {t('expand_all')}
          </a> |
          <a href="#" onclick={event => collapseAll(event)}>
            {t('collapse_all')}
          </a>
        </td>
      </tr>
    </thead>
    <tbody if={state.data}>
      <tr each={person in state.data.records}>
        <td class="checkbox pl-0">
          <dfk-input
            name="filter"
            type="checkbox"
            value={isActive(person)}
            update-handler={values => toggle(person)}
          />
        </td>
        <td>
          <a
            onclick={event => expandToggle(person, event)}
            class={hasArticles(person) ? 'has-articles' : 'no-articles'}
          >
            {displayName(person)}&nbsp;

            <template if={hasArticles(person)}>
              ({countFor(person)})
            </template>
          </a>

          <div if={person.expanded}>
            <div if={person.Wohnort}>
              Wohnort: <strong>{person.Wohnort}</strong>
            </div>

            <div if={person.Funktion}>
              Funktion: <strong>{person.Funktion}</strong><br />
            </div>

            <div if={person.Spezifikation}>
              Spezifikation: <strong>{person.Spezifikation}</strong>
            </div>

            <div if={person.GND_T}>
              GND-ID: <a href="https://d-nb.info/gnd/{person.GND_T}" target="_blank">{person.GND_T}</a>
            </div>
          </div>
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <script>
    import search from '../lib/search.instance'
    import DfkInput from '@dfk-paris/frontend/src/components/input.riot'
    import {Url} from '@wendig/lib'

    export default class {
      static components = {DfkInput}

      onBeforeMount(props, state) {
        this.sortExisting = this.sortExisting.bind(this)
        this.sortApply = this.sortApply.bind(this)

        state.page = 1
        state.active = {}
        state.fields = {
          fields: [
            {name: 'Spezifikation', label: 'Name', direction: 'asc'},
            {name: 'occurrence', label: 'Häufigkeit', direction: 'desc'}
          ],
          default: 'occurrence'
        }
      }

      onBeforeUpdate(props, state) {
        let active = {}
        for (const bucket of props.aggregation.buckets) {
          active[bucket.key] = bucket['doc_count']
        }

        this.state.active = active
      }

      onMounted() {
        this.fetch()
      }

      fetch() {
        const sort = this.tags['order-control'][0].effective()

        let criteria = {
          page: this.state.page,
          terms: this.state.filter,
          occurrence: this.props.aggregation.buckets,
          sort: sort['sort'],
          sortDirection: sort['direction']
        }

        console.log(criteria, 'ccc')

        search.people(criteria).then(data => {
          this.update({data})
        })
      }

      sortExisting() {
        const {sort, sortDirection} = this.state

        return {sort, direction: sortDirection}
      }

      sortApply(values) {
        const mapping = {
          direction: 'sortDirection'
        }

        for (const [k, v] of Object.entries(values)) {
          const field = mapping[k] || k

          if (v === null && this.state.hasOwnProperty(field)) {
            delete this.state[field]
          } else {
            this.state[field] = v
          }

          this.state['page'] = 1
        }

        this.state['page'] = 1

        this.fetch()
      }

      onPageTo(newPage) {
        this.state.page = newPage
        this.fetch()
      }

      filter(newFilter) {
        this.state.filter = newFilter
        this.fetch()
      }

      expandToggle(person, event) {
        if (event) event.preventDefault()

        person.expanded = !person.expanded
        this.update()
      }

      expandAll( event) {
        if (event) event.preventDefault()

        for (const r of this.state.data.records) {
          r.expanded = true
        }

        this.update()
      }

      collapseAll( event) {
        if (event) event.preventDefault()

        for (const r of this.state.data.records) {
          r.expanded = false
        }

        this.update()
      }

      checkAll() {
        const people = this.state.data.records.map(e => e.Spezifikation)
        const url = Url.current()
        url.updateHashParams({person: people.join('|')})
        url.apply()
      }

      isActive(person) {
        const url = Url.current()
        let people = url.hashParams()['person']
        people = (people ? people.split('|') : [])

        return people.includes(person.Spezifikation)
      }

      toggle(person) {
        const url = Url.current()
        let people = url.hashParams()['person']
        people = (people ? people.split('|') : [])

        const i = people.indexOf(person.Spezifikation)
        if (i == -1) people.push(person.Spezifikation)
        else people.splice(i, 1)

        url.updateHashParams({person: people.join('|')})
        url.apply()
      }

      onClose(event) {
        event.preventDefault()

        this.props.onClose(event)
      }

      hasArticles(person) {
        return this.countFor(person) > 0
      }

      countFor(person) {
        return this.state.active[person.Spezifikation]
      }

      displayName(person) {
        const names = [person.Name, person.Vorname].filter(e => !!e)

        return names.length > 0 ? names.join(', ') : person.Spezifikation
      }
    }
  </script>
</person-selector>
